export const PUBLIC_ENV_GLOBAL = '__NEXT_PUBLIC_ENV'
